import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdmService {

  constructor(private http: HttpClient) { }

  registriation(nidNo: string, bachlorScore: any, bachlorPercent: any, bachlorCertFilename: string, bachlorCardFilename: string, nidFilename: string, emailAddress1: string, orgid: number, appstatusid: number, fullNameAr: string, fullNameEn: string) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admcandidate`, { nidNo, bachlorScore, bachlorPercent, bachlorCertFilename, bachlorCardFilename, nidFilename, emailAddress1, orgid, appstatusid, fullNameAr, fullNameEn });
  }
  addbasicData(id: any, fullNameAr: string, fullNameEn: string, dob: string,
    addressL1Ar: string, addressL1En: string, addressL2Ar: string,
    addressL2En: string, personalMob1: string, personalMob2: string,
    emergencyMob1: string, emergencyMob2: string, homeTel: string,
    sec1NotesAr: string, sec1NotesEn: string, photoFilename: string,
    milStatusid: any, addressCountryid: any, addressRegionid: any,
    addressProvinceid: any, addressCityid: any, maritalStatusid: any, gender: string,
    sec1Entrydate: any) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandidatesec1/${id}`, {
      id, fullNameAr, fullNameEn, dob,
      addressL1Ar, addressL1En, addressL2Ar,
      addressL2En, personalMob1, personalMob2,
      emergencyMob1, emergencyMob2, homeTel,
      sec1NotesAr, sec1NotesEn, photoFilename,
      milStatusid, addressCountryid, addressRegionid,
      addressProvinceid, addressCityid, maritalStatusid, gender, sec1Entrydate
    });
  }

  addSection1CandData(id: any, livewithid: any, livewithOther: string, relative1Mob: string,
    relative2Mob: string, relation1: string, relation2: string,
    siblingsCount: any, candSiblingsRank: any, sec2Entrydate: any) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandidatesec2/${id}`, {
      id, livewithid, livewithOther, relative1Mob,
      relative2Mob, relation1, relation2,
      siblingsCount, candSiblingsRank, sec2Entrydate
    });
  }

  addSection2CandData(id: any, sec3Entrydate: any) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandidatesec3/${id}`, {
      id, sec3Entrydate
    });
  }

  addSection3CandData(id: any, termsAcceptedBy: any, termsAcceptedOn: any, appstatusid: any, termsAccepted: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandidatesec4/${id}`, {
      id, appstatusid, termsAccepted, termsAcceptedBy, termsAcceptedOn
    });
  }


  addPersionalInterViewData(id: any, interviewRscore: string, interviewComment: string, attitudeRscore: string,
    attitudeComment: string, interviewVduLink: string, interviewDate: any, appstatusid: any) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdateinterview/${id}`, {
      id, interviewRscore, interviewComment, attitudeRscore, attitudeComment, interviewVduLink, interviewDate, appstatusid
    });
  }

  addPersionalInterViewDataAndUsername(id: any, interviewRscore: string, interviewComment: string, attitudeRscore: string,
    attitudeComment: string, interviewVduLink: string, interviewDate: any, appstatusid: any, currentUserName: string, interviewWritingRscore: string, interviewWritingComment: string) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdateinterview/${id}/${currentUserName}`, {
      id, interviewRscore, interviewComment, attitudeRscore, attitudeComment, interviewVduLink, interviewDate, appstatusid, interviewWritingRscore, interviewWritingComment
    });
  }

  addMedicalChekData(id: any, medicalStatus: string, medicalComment: string, medicalDate: any, appstatusid: any) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdatemedical/${id}`, {
      id, medicalStatus, medicalComment, medicalDate, appstatusid
      //, medicalDate
    });
  }

  addMedicalChekDataAndUsername(id: any, medicalStatus: string, medicalComment: string, medicalDate: any, appstatusid: any, currentUserName: string) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdatemedical/${id}/${currentUserName}`, {
      id, medicalStatus, medicalComment, medicalDate, appstatusid
      //, medicalDate
    });
  }

  getQuestionSection2() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestion`);
  }

  getMaritalStatus() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmaritalstatus`);
  }

  getMilStatus() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmilstatus`);
  }

  getAllNewCandidateInquiries() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admcandidate`);
  }

  getCandidateInquiries(cid: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admgetcandidatebyid/${cid}`);
  }

  getAllAdmCands() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admcandidateall`);
  }

  getCandidateInquiriesByCurrentUserName(username: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admgetcandidatebyuser/${username}`);
  }

  getCandidateById(candidateId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admcandidate/${candidateId}`);
  }

  addEvaluateData(id: any, acceptanceComment: string, acceptanceStatus: string, acceptanceDate: any, appstatusid: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdateevaluation/${id}`, {
      id, acceptanceComment, acceptanceStatus, acceptanceDate, appstatusid
    });
  }

  addEvaluateDataAndUsername(id: any, acceptanceComment: string, acceptanceStatus: string, acceptanceDate: any, appstatusid: any, currentUsername: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdateevaluation/${id}/${currentUsername}`, {
      id, acceptanceComment, acceptanceStatus, acceptanceDate, appstatusid
    });
  }

  getQuestionSection2ByOrgAndSec(orgNumber: number, secNumber: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestionbysection/${orgNumber}/${secNumber}`);
  }

  getQuestionByCandidateAndSec(candId: number, secNumber: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admcandidatequestionbycandidate/${candId}/${secNumber}`);
  }

  getQuestionById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestion/${id}`);
  }

  getQuestionListAnswerData(orgId: number, questionId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestionvaluesbyquestion/${orgId}/${questionId}`);
  }

  getAllLiveWith() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admlivewith`);
  }

  updateCanditeAnsu(id: any, valueDesc: String) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandidatequestion`, {
      id, valueDesc
    });
  }

  // addcanEnglishTest
  addcanEnglishTest(candidateid: any, thanaweya: any, cefr: string, rn: number, ieltsFilename: string) {
    // return this.http.post<any>(
    //   `${environment.API_URL_ADM}/api/admmoodle`, { candidateid, p1Gv, p2Ra, p2Rb, p3Wa, p3Wb, moodleTotal, slWr, slSp, thanaweya, moodleLink });

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admlanguage`, { candidateid, thanaweya, cefr, rn, ieltsFilename });
  }

  getMoodelTestByCandID(candidateid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmoodle/${candidateid}`);
  }

  updateStatusEnglishTest(id: any, appstatusid: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandupdatestatus/${id}`, {
      id, appstatusid
    });

  }

  //get all
  getChronicDiseases() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admdisease`);
  }

  //get disease by cand Id
  getDiseasesByCandId(cid: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admdiseasebycandidate/${cid}`);
  }

  addChronicDiseases(candidateid: any, diseasesid: any, diseaseRemark: string) {

    // userImageFile: File
    // Handle upload user image (file)
    // const formData: FormData = new FormData();
    // formData.append('file', userImageFile, userImageFile.name);

    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admcandidatedisease`, {
      candidateid, diseasesid, diseaseRemark
    });
  }

  updateChronicDiseases(id: any, candidateid: any, diseasesid: any, diseaseRemark: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandidatedisease/${id}`, {
      id, candidateid, diseasesid, diseaseRemark
    });
  }
  //get all
  getCandNewCode(orgId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admgetcandidatenewcode/${orgId}`);
  }

  // Application statuses
  getAppStatuses() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admappstatus`);
  }

  geAppStatus(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admappstatus/${id}`);
  }

  addAppStatus(orgid: number, appStatusNameAr: string, appStatusNameEn: string, orderNo: number, startStatus: string, endStatus: string) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admappstatus`, { orgid, appStatusNameAr, appStatusNameEn, orderNo, startStatus, endStatus });
  }

  deleteAppStatus(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admappstatus/${id}`);
  }

  updateAppStatus(orgid: number, id: number, appStatusNameAr: string, appStatusNameEn: string, orderNo: number, startStatus: string, endStatus: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admappstatus/${id}`, { id, orgid, appStatusNameAr, appStatusNameEn, orderNo, startStatus, endStatus });
  }

  getMilStatuses() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmilstatus`);
  }

  geMilStatusById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmilstatus/${id}`);
  }

  addMilStatus(milStatusNameAr: string, milStatusNameEn: string, orderNo: number) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admmilstatus`, { milStatusNameAr, milStatusNameEn, orderNo });
  }

  deleteMilStatus(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admmilstatus/${id}`);
  }

  updateMilStatus(id: number, milStatusNameAr: string, milStatusNameEn: string, orderNo: number) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admmilstatus/${id}`, { id, milStatusNameAr, milStatusNameEn, orderNo });
  }

  getFmMembers() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admfamilymember`);
  }

  geFmMemberById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admfamilymember/${id}`);
  }

  addFmMember(memberNameAr: string, memberNameEn: string, orderNo: number) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admfamilymember`, { memberNameAr, memberNameEn, orderNo });
  }

  deleteFmMember(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admfamilymember/${id}`);
  }

  updateFmMember(id: number, memberNameAr: string, memberNameEn: string, orderNo: number) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admfamilymember/${id}`, { id, memberNameAr, memberNameEn, orderNo });
  }

  //Maritia Status
  getMartialStatuses() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmaritalstatus`);
  }

  addMartialStatuses(maritalStatusNameAr: string, maritalStatusNameEn: string, orderNo: number) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admmaritalstatus`, { maritalStatusNameAr, maritalStatusNameEn, orderNo });
  }

  deleteMartialStatuses(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admmaritalstatus/${id}`);
  }

  getMartialStatus(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admmaritalstatus/${id}`);
  }
  updateMartialStatus(id: any, maritalStatusNameAr: string, maritalStatusNameEn: string, orderNo: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admmaritalstatus/${id}`, { id, maritalStatusNameAr, maritalStatusNameEn, orderNo });
  }


  //Live With
  getLiveWithList() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admlivewith`);
  }

  addLiveWith(livewithNameAr: string, livewithNameEn: string, orderNo: number) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admlivewith`, { livewithNameAr, livewithNameEn, orderNo });
  }

  deleteLiveWith(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admlivewith/${id}`);
  }

  getLiveWith(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admlivewith/${id}`);
  }
  updateLiveWith(id: any, livewithNameAr: string, livewithNameEn: string, orderNo: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admlivewith/${id}`, { id, livewithNameAr, livewithNameEn, orderNo });
  }


  //chronic disease
  getChronicDiseaseList() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admdisease`);
  }

  addChronicDisease(diseaseDescAr: string, diseaseDescEn: string, orderNo: number) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admdisease`, { diseaseDescAr, diseaseDescEn, orderNo });
  }

  deleteChronicDisease(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admdisease/${id}`);
  }

  getChronicDisease(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admdisease/${id}`);
  }
  updateChronicDisease(id: any, diseaseDescAr: string, diseaseDescEn: string, orderNo: any) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admdisease/${id}`, { id, diseaseDescAr, diseaseDescEn, orderNo });
  }

  getQuestions() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestion`);
  }

  geQuestionById(id: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestion/${id}`);
  }

  addQuestion(orgid: number, questionDescAr: string, questionDescEn: string, questionType: string, sectionNo: number, orderNo: number, activeFlag: string, requiredFlag: string) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admquestion`, { orgid, questionDescAr, questionDescEn, questionType, sectionNo, orderNo, activeFlag, requiredFlag });
  }

  deleteQuestion(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admquestion/${id}`);
  }

  updateQuestion(id: number, orgid: number, questionDescAr: string, questionDescEn: string, questionType: string, sectionNo: number, orderNo: number, activeFlag: string, requiredFlag: string) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admquestion/${id}`, { id, orgid, questionDescAr, questionDescEn, questionType, sectionNo, orderNo, activeFlag, requiredFlag });
  }

  getQuestionAnswers(orgid: number, questionid: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestionvaluesbyquestion/${orgid}/${questionid}`);
  }

  geQuestionAnswerById(answerId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admquestionvalue/${answerId}`);
  }

  addQuestionAnswer(orgid: number, questionid: number, valueDescAr: string, valueDescEn: string, orderNo: number) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admquestionvalue`, { orgid, questionid, valueDescAr, valueDescEn, orderNo });
  }

  deleteQuestionAnswer(answerId: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admquestionvalue/${answerId}`);
  }

  updateQuestionAnswer(id: number, orgid: number, questionid: number, valueDescAr: string, valueDescEn: string, orderNo: number) {
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admquestionvalue/${id}`, { id, orgid, questionid, valueDescAr, valueDescEn, orderNo });
  }

  getLastAddedQuestion() {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/admgetlastquestionid`, {});
  }

  deleteAnswersByQuestionId(qId: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/admdeletequestionvalues/${qId}`);
  }

  // get cand moodle test 
  getCandEnglishTest(candId: number) {
    // return this.http.get<any>(`${environment.API_URL_ADM}/api/admmoodle/${candId}`);
    return this.http.get<any>(`${environment.API_URL_ADM}/api/admlanguage/${candId}`);
  }

  // get cand moodle test 
  getCandChronicDiseases(candId: number) {
    return this.http.get<any>(`${environment.API_URL_ADM}/api/admdiseasebycandidate/${candId}`);
  }

  // get adm dashboard status
  getAdmDashboardStatus(username: string) {
    return this.http.get<any>(`${environment.API_URL_ADM}/api/admdashboardstatus/${username}`);
  }

  // get admdashboardpending
  getAdmDashboardPending(username: string) {
    return this.http.get<any>(`${environment.API_URL_ADM}/api/admdashboardpending/${username}`);
  }

  candVerify(id: number, username: string, appstatusid: number, verifiedBy: string, verificationDate: any, invitationDate: any, invitationBatch: string, invitationBy: string) {
    // let candid = id;
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/admcandverificate/${id}/${username}`, {
      id, appstatusid, verifiedBy, verificationDate, invitationDate, invitationBatch, invitationBy
    });
  }

  getStatisticsReport() {
    return this.http.get<any>(`${environment.API_URL_ADM}/api/admsummary`);
  }
  getCandProvinceReport() {
    return this.http.get<any>(`${environment.API_URL_ADM}/api/admcandidatebyprovince/`);
  }

  admLoadLangFomInterface(username: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admloadlangfrominterface/${username}`);
  }

  getAdmCandidateByInviteDates(startDate: string, endDate: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/admcandidatebyinvitedate/${startDate}/${endDate}`);
  }

}
